// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';



class Upm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })


    }


    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='1' />
                <div className='dv_vpm_body'>
                    <div className={`flex-col dv_vpm_main_body`}>
                        <div className='dv_banner_wrap'><img src={require("./assets/img/convoy/55_000025.jpg")} /></div>
                        <div className='dv_vpm_content_wrap'>
                            <div className='dv_trake_change flex-row between'>
                                <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>名校国际本科</div>
                                <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>名校硕士衔接</div>
                                <div className={this.state.currentTab == 2 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(2)}>本硕直通项目</div>
                            </div>
                            {this.state.currentTab == 0 && <div>
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000059.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000060.jpg")} />

                            </div>}
                            {this.state.currentTab == 1 && <div>
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000061.jpg")} />

                            </div>}
                            {this.state.currentTab == 2 && <div>
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000062.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000063.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000064.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000065.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000066.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000067.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000068.jpg")} />
                            </div>}

                        </div>
                    </div>


                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Upm);